import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import Assembleia from '../../../../models/assembleia/assembleia.model';
import { AbStepAssembleia } from 'app/abstract/full-pages/assembleia/step-assembleia.abstract';

@Injectable({
    providedIn: 'root'
})
export class StepAssembleiaService extends AbStepAssembleia {


    public qtdFinalizadas: number = 1;
    public mostrarConfgGerais: boolean = false;
    public assembleia = new Assembleia();

    public getResultadoCompleted(): number {
        return this.qtdFinalizadas;
    }

    observableCompleted(): Observable<boolean> {
        return new Observable((observer) => {
            setTimeout(() => {
                observer.next(true);
                observer.complete();
            }, 100);
        })
    }

    public setResultadoCompleted(): Observable<any> {
        this.qtdFinalizadas = this.qtdFinalizadas + 1;
        return this.observableCompleted();
    }

    public setVoltarResultadoCompleted(): Observable<any> {
        this.qtdFinalizadas = this.qtdFinalizadas - 1;
        return this.observableCompleted();
    }

    public reiniciarContagem() {
        this.qtdFinalizadas = 1;
    }

    public terminarContagem() {
        this.qtdFinalizadas = 4;
    }
}


